import { dpAssert } from "@/sharedTypes/helpers";
import MapperEntity from "../Mapper/Mapper";
import { findObjectsWithProperty } from "../XmlEditor/XmlEditor";
import { Note as note } from "@/sharedTypes/main";
import { ManagerEntity } from "@/shared/globalFunctions";

class XmlDiagnostic {
    // get fingers that have double fing
    showWrongFings() {
        dpAssert(ManagerEntity.renderer)
        const object = MapperEntity.xmlObject;
        const technicalArr: any[] = [];
        const technicals = findObjectsWithProperty(object, 'name', 'technical', technicalArr);
        if (!technicals || !technicals.length) {
          return;
        }
        let currentInd = 0;
        for (const tech of technicals) {
            let fingerCount = 0;
            if (tech.elements) {
                for (const el of tech.elements) {
                    if (el.name === "fingering") {
                        fingerCount++
                        currentInd = currentInd + 1;
                    }
                }
            } else continue;
            if (fingerCount > 1) {
                const startIndex = currentInd - fingerCount;
                const fings = document.getElementsByClassName("fing");
                const wrongFings = []
                for (let i = 0; i < fingerCount; i++) {
                    wrongFings.push(fings[startIndex + i])
                }
                for (const wrongFing of wrongFings) {
                    ManagerEntity.renderer.changeElementColor(wrongFing, "red");
                }
            }
        }
    }
    getExtraNotes() {
        dpAssert(ManagerEntity.core && ManagerEntity.renderer);
        const extraNotes: {
            [measureIndex: string]: note[]
        } = {}
        const measures = ManagerEntity.core._timemap;
        for (const measure of measures) {
            for (let i = 0; i < measure.notes.length; i++) {
                const curr = measure.notes[i];
                for (let m = i + 1; m < measure.notes.length; m++) {
                    const next = measure.notes[m];
                    if (
                        curr.midi.time === next.midi.time
                        &&
                        curr.midi.pitch === next.midi.pitch
                        &&
                        curr.midi.staffPos === next.midi.staffPos
                    ) {
                        if (extraNotes.hasOwnProperty(measure.measureIndex)) {
                            extraNotes[measure.measureIndex].push(next);
                        } else {
                            extraNotes[measure.measureIndex] = [next]
                        }
                        const noteEl = document.getElementById(next.noteId);
                        ManagerEntity.renderer.changeElementColor(noteEl, "red");
                    }
                }
            }
        }
        return extraNotes;
    }
}

const XmlDiagnosticEntity = new XmlDiagnostic();
export default XmlDiagnosticEntity;
